// Replace these with real API calls using fetch or axios
export const getWeekOffs = async () => {
  return [
    { id_week_off: 1, id_employee: 101, week_off_day: 'Monday', effective_from: '2025-07-01', effective_to: null },
  ];
};

export const addWeekOff = async (data) => {
  console.log("Adding", data);
};

export const updateWeekOff = async (data) => {
  console.log("Updating", data);
};

export const deleteWeekOff = async (id) => {
  console.log("Deleting ID", id);
};
